<template>
  <section class="grid_text_image big_container new-video-sec-full-bleed">
    <div class="grid_item grid_info">
      <h2
        class="main_heading grid_text_image_heading color-white"
        v-html="shopifyData.secHeading"
      />
      <a :href="shopifyData.link" class="cta_btn cta_btn-white" v-html="shopifyData.btnText" />
    </div>

    <div class="grid_item grid_item_img">
      <div class="grid_img-wrap line-h-0 d-block">
        <template v-if="shopifyData.checkImage === 'true'">
          <div ref="lazyContainer" class="video-lazy-container">
            <transition name="fade">
              <video
                v-if="isVideoLoaded"
                ref="videoElement"
                class="video-el"
                autoplay
                loop
                muted
                playsinline
                webkit-playsinline
                preload="metadata"
                controlsList="nodownload"
                disablepictureinpicture
                :poster="shopifyData.posterImg"
              >
                <source :src="shopifyData.videoWebm" type="video/webm" />
                <source :src="shopifyData.videolink" type="video/mp4" />
              </video>
            </transition>
          </div>
        </template>

        <template v-else>
          <img
            v-lazy="shopifyData.imgUrl.src"
            class="grid_img"
            :src-placeholder="shopifyData.imgUrl.placeholder"
            :alt="shopifyData.imgUrl.alt || 'Banner Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Grid Image"
            width=""
            height=""
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: { type: Object, required: true },
  },

  data() {
    return {
      isVideoLoaded: false, // lazy load trigger
    };
  },

  mounted() {
    this.initLazyLoader();
  },

  beforeMount() {
    if (this.videoObserver) this.videoObserver.disconnect();
    if (this.playObserver) this.playObserver.disconnect();
  },

  methods: {
    // STEP 1 — Lazy load the video TAG only when near viewport
    initLazyLoader() {
      const container = this.$refs.lazyContainer;
      if (!container) return;

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.isVideoLoaded = true;
            this.$nextTick(() => this.initVideoPlayer());
            this.videoObserver.disconnect();
          }
        },
        {
          rootMargin: '200px', // Load video 200px before coming into view
        }
      );

      this.videoObserver.observe(container);
    },

    // STEP 2 — Initialize video autoplay + controls
    initVideoPlayer() {
      const video = this.$refs.videoElement;
      if (!video) return;

      video.muted = true;

      const isMobile = window.innerWidth <= 575;
      video.controls = isMobile;

      // STEP 3 — Play/Stop when video enters or leaves viewport
      this.playObserver = new IntersectionObserver(
        (entries) => {
          const inView = entries[0].isIntersecting;

          if (inView) {
            const playPromise = video.play();
            if (playPromise) {
              playPromise.catch(() => {
                video.muted = true;
                video.play();
              });
            }
          } else {
            video.pause();
          }
        },
        { threshold: 0.35 }
      );

      this.playObserver.observe(video);
    },
  },
};
</script>

<style scoped>
.main_heading {
  line-height: 62px;
}

/* Grid Text Image */
.grid_text_image {
  background: #000;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  /* grid-template-columns:  minmax(auto, 480px) minmax(auto, 720px); */
  align-items: center;
  justify-content: center;
  /* gap: 45px; */
}
.grid_info {
  display: none;
}
.fade-enter-active {
  transition: opacity 0.6s ease;
}
.fade-enter {
  opacity: 0.1;
}

@media only screen and (max-width: 991px) {
  /* Grid Text Image */
  .grid_text_image_heading {
    margin-bottom: 45px;
  }
  .grid_info {
    /* display: block; */
    padding: 26px 15px 30px;
  }
  .grid_text_image {
    text-align: center;
  }
  .grid_item_img {
    grid-row-start: -1;
  }
}
@media only screen and (max-width: 767px) {
  .main_heading {
    font-size: 42px;
  }
}
</style>
